import { put, call, select, race } from 'redux-saga/effects';
import {
  FETCH_ORDERS,
  ACCEPT_ORDER,
  GET_ORDER,
  ADD_MEMO,
  CLOSE_ORDER,
  REFUSE_CLOSE_ORDER,
  // CREATE_ORDER,
  SHOW_ASSIGN_DIALOG,
  SHOW_PRICE_DIALOG,
  SHOW_SERVICE_TIME_DIALOG,
  SHOW_ASSIGN_WORKER_DIALOG,
  SHOW_ASSIGN_WORKER_SELECT_DIALOG,
  // SET_WAIT_EXPRESS_STATUS,
  SET_COMPLETE_STATUS,
  SET_WORKER_COMPLETE,
  TOGGLE_ORDER_TAG,
  LOCK_ORDER_FEE,
  ORDER_PREVIEW,
  CONFIRM_LOCATION,
  SHOW_CREATE_ORDER_DIALOG,
  SHOW_APPEAL_DIALOG,
  SHOW_IMAGE_VIEW_DIALOG,
  TENANT_CLOSE_ORDER,
  ORDER_DEDUCTION,
  SET_ACCEPT_STATUS,
  RE_SERVICE_DIALOG,
  SEND_WORKER_TO_USER,
  SHOW_EXPRESS_DIALOG,
  SHOW_EXPRESS_DETAIL_DIALOG,
  SHOW_ACCESSORY_DETAIL_DIALOG,
  SAVE_ORDER_ACCESSORY,
  SHOW_ORDER_EVALUATE_DIALOG,
  SHOW_ORDER_REMINDER,
} from './actionTypes';
import { RTM_ORDER_UPDATED } from '../socket/actionTypes';
import { createModal } from 'redux-saga-modal';
import * as services from './services';
import * as messageActions from '@/models/messages/actions'
import * as actions from './actions';
import { getConvEntriesSelector } from '@/models/conversations/selectors';
import { getCurrentUser } from '@/models/user/selectors';
import { removeConv } from '@/models/conversations/actions';
import { convRefresh } from '@/models/socket/actions';
import { message, Modal } from 'antd';

const { fromJS } = require('immutable');

const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

export default {
  *[FETCH_ORDERS]({ payload }) {
    const result = yield call(services.getOrderList, payload.params);

    yield put(actions.ordersFetched(result));
  },

  *[GET_ORDER]({ payload }) {
    const order = yield call(services.getOrder, payload.id);

    yield put(actions.getOrderSuccess(order));
  },

  *[ADD_MEMO]({ payload }) {
    yield call(services.addMemo, payload);
    yield put(actions.addMemoSuccess(payload));
  },

  *[CLOSE_ORDER]({ payload }) {
    yield call(services.closeOrder2, payload);
    const order = yield call(services.getOrder, payload.id);
    yield put(actions.orderUpdated(order));
    yield put(messageActions.playActionAudio())
    message.success('已取消');
  },
  *[REFUSE_CLOSE_ORDER]({ payload }) {
    yield call(services.refuseCloseOrder, payload);
    yield put(messageActions.playActionAudio())
    message.success('已拒绝');
  },

  *[SET_ACCEPT_STATUS]({ payload }) {
    yield call(services.setAcceptStatus, payload.id, { status: payload.status });
    yield put(messageActions.playActionAudio())
    message.success('提交成功');
  },

  *[SEND_WORKER_TO_USER]({ payload }) {
    const { params } = payload;
    yield call(services.sendWorkerToUser, params.id);
    yield put(messageActions.playActionAudio())
    message.success('通知成功');
    if (params.onSuccess) {
      params.onSuccess()
    }
  },
  *[TENANT_CLOSE_ORDER]({ payload }) {
    yield call(services.tenantCloseOrder, payload);
    yield put(messageActions.playActionAudio())
    message.success('申请已提交');
  },
  *[SHOW_CREATE_ORDER_DIALOG]({ payload }) {
    const { params } = payload;
    const modal = createModal('CREATE_ORDER_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (submit) {
      yield modal.hide();
    } else {
      yield modal.destroy();
    }
  },

  *[RE_SERVICE_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('RE_SERVICE_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (submit) {
      yield modal.hide();
    } else {
      yield modal.destroy();
    }
  },
  *[SHOW_ASSIGN_WORKER_SELECT_DIALOG]({ payload }) {
    const { params } = payload;
    const { onSuccess } = params;
    const modal = createModal('ASSIGN_WORKER_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    const { selected, worker } = submit.payload;
    onSuccess({ id: selected, worker })
    yield modal.hide();
  },
  // *[CREATE_ORDER]({ payload }) {
  //   yield call(services.createOrder, payload)
  //   // 只需请求，其他事情交给socket消息

  //   message.success('已创建')
  // },

  *[ACCEPT_ORDER]({ payload }) {
    yield call(services.receiveOrder, payload.id, { convId: payload.convId });
    if (payload.onSuccess) {
      payload.onSuccess()
    }
  },

  *[SAVE_ORDER_ACCESSORY]({ payload }) {

    yield call(services.saveOrderAccessory, payload);
    if (payload.onSuccess) {
      payload.onSuccess()
    }
  },

  *[RTM_ORDER_UPDATED]({ payload: id }) {
    const order = yield call(services.getOrder, id);
    yield put(actions.orderUpdated(order));
    // try {
    //   var audio = new Audio();
    //   audio.src = process.env.PUBLIC_URL + '/new_order.mp3';
    //   audio.play();
    //   audio.addEventListener('ended', () => {
    //     audio.remove();
    //   });
    // } catch (error) {

    // }
  },

  *[LOCK_ORDER_FEE]({ payload }) {
    const { id } = payload;

    yield call(services.lockFee, id);
  },

  *[SHOW_ASSIGN_DIALOG]({ payload }) {
    const { params } = payload;
    const { id, onSuccess } = params;

    if (!id) {
      return message.error('action:ORDER_ASSIGN_DIALOG missing id');
    }
    if (isTenantMode) {
      const user = yield select(getCurrentUser);
      params.tenantId = user.getIn(['staff', 'tenant', '_id']);
    }

    const modal = createModal('ORDER_ASSIGN_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    // assign
    const { selected: user } = submit.payload;
    try {
      const result = yield call(services.assignOrder, id, {
        user,
        type: 'manager',
      });
      onSuccess?.(result);
    } catch (err) {
      yield modal.destroy();
      throw err;
    }

    // update conversation
    const convs = yield select(getConvEntriesSelector);
    const conv = convs.find((conv) => conv.get('order_id') === id);
    if (conv) {
      yield put(removeConv(conv.get('_id')));
    }

    yield modal.hide();

    Modal.success({
      title: '操作成功',
      content: '工单已转让完成',
    });
  },

  *[SHOW_PRICE_DIALOG]({ payload }) {
    const { params } = payload;
    const { order, field, type, clickTarget, onSuccess } = params;
    const modal = createModal('ORDER_PRICE_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }
    try {
      // const api =
      //   field === 'fee' ?
      //     services.updatePrice :
      //     type === 'order' ?
      //       services.updateWorkerFee :
      //       services.updateWorkerServiceFee;
      let api = services.updateWorkerServiceFee
      if (field === 'fee') {
        api = services.updatePrice
        if (type === 'fixed_price') {
          api = services.updateOrderPubOne
        }
      } else if (field === 'order') {
        api = services.updateWorkerFee
      }

      yield call(api, order.get('_id'), submit.payload[field]);
      // yield put(messageActions.playActionAudio())
      onSuccess();
    } catch (err) {
      yield modal.destroy();
      throw err;
    }

    yield modal.hide();

    message.success('已更新');
  },

  *[SHOW_EXPRESS_DIALOG]({ payload }) {
    const { params } = payload;
    const { order, onSuccess } = params;
    const modal = createModal('ORDER_EXPRESS_DIALOG');
    yield modal.show(params);
    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });
    if (!submit) {
      return yield modal.destroy();
    }
    const { data, orderId, dataList } = submit.payload;
    console.log(dataList)
    try {
      const result = yield call(services.addExpress, orderId, dataList);
      // const result = yield call(services.saveOrderExpress, data.order_id, data.data);
      onSuccess?.(result);
    } catch (err) {
      yield modal.destroy();
      throw err;
    }
    yield modal.hide();
    message.success('保存成功');
  },

  *[SHOW_ACCESSORY_DETAIL_DIALOG]({ payload }) {

    const { params } = payload;
    const { onSuccess } = params;
    const modal = createModal('ORDER_ACCESSORY_DIALOG');
    yield modal.show(params);

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })
    if (submit) {

      const { action, id, data } = submit.payload;
      if (action === 'save') {
        try {
          const result = yield call(services.saveOrderAccessory, data);
          onSuccess?.(result);
          message.success('保存成功');
          yield modal.hide()
        } catch (err) {
          yield modal.destroy();
          throw err;
        }
      }
      if (action === 'delete') {
        try {
          const result = yield call(services.deleteOrderAccessory, id);
          onSuccess?.(result);
          message.success('删除成功');
          yield modal.hide()
        } catch (err) {
          yield modal.destroy();
          throw err;
        }
      }
    } else {
      yield modal.destroy()
    }
  },

  *[SHOW_SERVICE_TIME_DIALOG]({ payload }) {
    const { params } = payload;
    const modal = createModal('SERVICE_TIME_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    // assign
    const { service_time } = submit.payload;

    try {
      yield call(services.updateServiceTime, params.id, service_time);
    } catch (err) {
      yield modal.destroy();
      throw err;
    }

    yield modal.hide();

    message.success('已更新');
  },
  *[SHOW_ORDER_EVALUATE_DIALOG]({ payload }) {
    const { params } = payload;
    const modal = createModal('ORDER_EVALUATE_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    try {
      yield call(services.setEvaluate, submit.payload);
    } catch (err) {
      yield modal.destroy();
      throw err;
    }

    yield modal.hide();
    const order = yield call(services.getOrder, params.orderId);
    yield put(actions.orderUpdated(order));
  },

  *[SHOW_ASSIGN_WORKER_DIALOG]({ payload }) {
    const { params } = payload;
    const { order, field, type, onSuccess } = params;
    const modal = createModal('ASSIGN_WORKER_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    // assign
    const { selected, workerQuoteOrNot } = submit.payload;

    const modal2 = createModal('ORDER_PRICE_DIALOG');

    try {
      if (workerQuoteOrNot) {
        yield call(services.assignWorker, params.id, selected);
        yield modal.hide();
      } else {

        yield modal2.show({
          title: '师傅工费单',
          order: fromJS({ ...order, worker_fee: [] }),
          field: 'worker_fee',
          type: 'worker_service',
        });
        const { submit, hide } = yield race({
          submit: modal2.takeSubmit(),
          hide: modal2.takeHide(),
        });

        if (!submit) {
          return yield modal2.destroy();
        }
        yield call(services.assignWbjWorker, {
          orderId: params.id,
          workerId: selected,
          worker_fee: submit.payload.worker_fee
        });

        yield modal.hide();
        yield modal2.hide();
      }

      // const order = yield call(services.getOrder, params.id);
      // yield put(actions.orderUpdated(order));
      yield put(convRefresh());
    } catch (err) {
      yield modal.destroy();
      yield modal2.destroy();
      throw err;
    }

    message.success('已指派');
  },
  *[SHOW_EXPRESS_DETAIL_DIALOG]({ payload }) {
    const { params } = payload;
    const modal = createModal('EXPRESS_DETAIL_DIALOG');
    yield modal.show(params);
    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }
  },
  *[SHOW_IMAGE_VIEW_DIALOG]({ payload }) {
    const { params } = payload;
    const modal = createModal('IMAGE_VIEW_DIALOG');
    yield modal.show(params);
    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }
  },

  *[SHOW_APPEAL_DIALOG]({ payload }) {
    const { params } = payload;
    const { onSuccess } = params;
    const modal = createModal('ORDER_APPEAL_DIALOG');
    yield modal.show(params);

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }
    const { isAppealClaim } = submit.payload;
    try {
      if (isAppealClaim) {
        const queryData = { ...submit.payload }
        delete queryData.type
        delete queryData.radiotype
        delete queryData.isAppealClaim
        queryData.images = queryData.images.map(item => item.url)
        yield call(services.orderClaim, queryData);
        const order = yield call(services.getOrder, params.order_id);
        yield put(actions.orderUpdated(order));
      } else {
        const result = yield call(services.appealOrder, params.order_id, submit.payload);
        onSuccess?.(result);
        //1 2 是客服发起的操作
        if (params.type == 1 || params.type == 2) {
          yield put(messageActions.playActionAudio())
        }
      }

      message.success('操作成功');
    } catch (err) {
      yield modal.destroy();
      throw err;
    }
    yield modal.hide();

  },

  *[ORDER_PREVIEW]({ payload }) {
    const modal = createModal('ORDER_PREVIEW');
    const order = yield call(services.getOrder, payload.id);
    yield put(actions.orderUpdated(order));

    yield modal.show({ ...payload, order });

    yield modal.takeHide();

    yield modal.hide();
  },

  // *[SET_WAIT_EXPRESS_STATUS]({ payload }) {
  //   yield call(services.setWaitExpressStatus, payload.id, payload.unset)

  //   const order = yield call(services.getOrder, payload.id)
  //   yield put(actions.orderUpdated(order))

  //   message.success('已设置')
  // },

  *[SET_COMPLETE_STATUS]({ payload }) {
    yield call(services.setCompleteState, payload.id);
    const order = yield call(services.getOrder, payload.id);
    yield put(actions.orderUpdated(order));
    yield put(messageActions.playActionAudio())
    if (isTenantMode) {
      message.success('已确认');
    } else {
      message.success('客服已确认完单');
    }
  },

  *[SET_WORKER_COMPLETE]({ payload }) {
    yield call(services.setWorkerComplete, payload.id);

    message.success('已确认');
  },

  *[TOGGLE_ORDER_TAG]({ payload }) {
    yield call(services.toggleTag, payload.id, payload.tag);
  },

  *[CONFIRM_LOCATION]({ payload }) {
    yield call(services.confirmLocation, payload.id, payload.data);
    yield put(messageActions.playActionAudio())
    message.success('已确认');
  },

  *[SHOW_ORDER_REMINDER]({ payload }) {
    const { params } = payload;
    const { order } = params;

    const modal = createModal('ORDER_REMINDER_DIALOG');

    yield modal.show({ ...payload });

    const { submit, hide } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    });

    if (!submit) {
      return yield modal.destroy();
    }

    const datas = submit.payload;

    try {
      let apiFun = services.remindWorkerService
      if (isTenantMode) {
        apiFun = services.tenantRemindWorkerService
      }
      const result = yield call(apiFun, order._id, datas);
      yield put(messageActions.playActionAudio())
      message.info('发送提醒成功');
    } catch (err) {
      yield modal.destroy();
      throw err;
    }
    yield modal.hide();

  },
};
